import { difference } from 'lodash';

import phoneUnification from './validation-utils';

interface Recipient {
  address: string;
  name?: string;
  notify?: boolean;
}

const isEmail = (address: string): boolean => {
  return address.indexOf('@') !== - 1;
};

export const getEmails = (recipients: Recipient[]): string[] => {
  const emails = recipients?.filter((recipient) => recipient?.address && isEmail(recipient.address) && recipient.notify !== false)?.map(recipient => recipient.address);
  return emails?.length > 0 ? emails : [''];
};

export const getPhones = (recipients: Recipient[]): string[] => {
  const phones = recipients?.filter((recipient) => recipient?.address && !isEmail(recipient.address) && recipient.notify !== false)?.map(recipient => phoneUnification(recipient.address));
  return phones?.length > 0 ? phones : [''];
};


export const getRecipients = (oldRecipients: Recipient[], newRecipients: string[]): { update: string[], add: string[] } => {
  const filteredNewRecipients = newRecipients.filter(r => r && r.trim());
  const oldAddresses = oldRecipients?.map(r => r.address) || [];
  
  const recipientsToRemove = difference(oldAddresses, filteredNewRecipients);
  const recipientsToAdd = difference(filteredNewRecipients, oldAddresses);
  
  return {
    update: recipientsToRemove,
    add: recipientsToAdd
  };
};

export const formatJobDescription = (description: string, foreign_id: string, isSessionsEnabled: boolean) => {
  return description || (foreign_id?.indexOf('_return') === -1 && isSessionsEnabled ? 'Returning to Base' : '')
}